import { z } from 'zod';
import { legalPersonSchema } from './ILegalPerson';
import { naturalPersonSchema } from './INaturalPerson';

const EditableLegalClientAddressSchema = z.object({
  idPostcode: z
    .number({ required_error: 'Postleitzahl ist verpflichtend' })
    .int()
    .min(1, 'Postleitzahl ist verpflichtend'),
  Street: z.string().nullable().optional(),
  Number: z.string().nullable().optional(),
  StreetAdditional: z.string().nullable().optional(),
});

export const EditableLegalClientSchema = naturalPersonSchema
  .and(legalPersonSchema)
  .and(
    z.object({
      idLegalClient: z.number().int(),
      idLegalClientType: z.number().int(),

      AddressArray: z.array(EditableLegalClientAddressSchema).min(1, {
        message: 'Mindestens eine Adresse ist erforderlich',
      }),
      Email: z.string().email().nullable(),

      data: z.object({
        addToLegalTransaction: z.boolean().optional(),
      }),
    })
  )
  .superRefine((data, ctx) => {
    if (
      data.data.addToLegalTransaction &&
      (data.Email === null || data.Email === '')
    ) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message:
          'E-Mail ist erforderlich, wenn für den Mandanten ein Account angelegt werden soll.',
        path: ['Email'],
      });
    }

    const addressAdditionalRequired = [
      { field: 'Street', displayName: 'Straße' },
      { field: 'Number', displayName: 'Hausnummer' },
    ];
    data.AddressArray.forEach((address, index) => {
      addressAdditionalRequired.forEach(({ field, displayName }) => {
        const value = address[field as keyof typeof address];
        if (
          !value ||
          (typeof value === 'string' && (value as string).trim() === '')
        ) {
          ctx.addIssue({
            code: z.ZodIssueCode.custom,
            message: `${displayName} ist erforderlich.`,
            path: ['AddressArray', index, field],
          });
        }
      });
    });
  });

export type IEditableLegalClient = z.infer<typeof EditableLegalClientSchema>;
